import React, { useState, useEffect } from 'react'
import { navigate } from "@reach/router"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
import * as Icons from 'images/icons/sidebar'
import { WithTip } from 'components/tooltip/with-tip'
import { NavItem_s, Sidebar_s, AppMode_s, AppModes_s } from 'components/wrapper/sidebar/sidebar-styles'
import { ShortcutHint_s } from 'styles/shortcut-styles'
import keyService, * as chord from "data/key"
import propertyService from "data/property"
import socketService, * as eventType from "data/socket"
import toggles from "feature-toggles"
import { local, setlocal } from 'data/lib/local-json'
import userService from 'data/user'

const Sidebar = (props) => {
  const [hintsVisible, setHintsVisible] = useState(false)
  const [selectedPropType, setPropType] = useState("Commercial")
  const [busy, setBusy] = useState(true)
  const [appMode, setAppMode] = useState(local('appMode') || 'property')
  const [currentUserHasAssetManagement, setCurrentUserHasAssetManagement] = useState(false)

  useEffect(() => {
    userService.getUsers().then(() => {
      const hasAM = _.includes(_.get(userService.getCurrent(), 'approles'), 'Asset Management')
      setCurrentUserHasAssetManagement(hasAM)
    })
  }, [])

  const navItems = [
    {
      name: 'Dashboard',
      hintText: 'D',
      icon: Icons.DashboardIcon,
      href: "/n/dashboard",
      visible: true,
      width: 85,
      multifamily: true,
      hospitality: true,
      visibleNoProperty: true
    },
    {
      name: 'Folder',
      hintText: 'F',
      icon: Icons.FolderIcon,
      href: "/n/folder/explorer",
      visible: true,
      width: 55,
      multifamily: true,
      hospitality: true,
      visibleNoProperty: true
    },
    {
      name: 'Property',
      hintText: 'P',
      icon: Icons.PropertyIcon,
      href: "/n/property/settings",
      visible: true,
      width: 70,
      multifamily: true,
      hospitality: true
    },
    {
      name: 'Property Market',
      hintText: 'M',
      icon: Icons.PropertyMarketIcon,
      href: "/n/property-market/inflation",
      visible: true,
      width: 125,
      multifamily: false,
      hospitality: false
    },
    {
      name: 'Tenant Market',
      hintText: 'T',
      icon: Icons.TenantMarketIcon,
      href: "/n/tenant-market/rent",
      visible: true,
      width: 110,
      multifamily: false,
      hospitality: false
    },
    {
      name: 'Reports',
      hintText: 'O',
      icon: Icons.ReportsIcon,
      href: "/n/reports",
      visible: true,
      width: 70,
      multifamily: true,
      hospitality: true
    },
    {
      name: 'Organization Settings',
      icon: Icons.SettingsIcon,
      href: "/n/admin/organization-settings",
      visible: _
        .chain(JSON.parse(localStorage.getItem("auth.profile")))
        .get("roletype.name")
        .isEqual("admin")
        .value()
      ,
      width: 155,
      multifamily: true,
      hospitality: true,
      visibleNoProperty: true
    }
  ]

  if(toggles.displayNewTenantMarket()) {
    navItems.splice(5, 0, {
      name: 'Recoveries',
      hintText: 'V',
      icon: Icons.RecoveriesIcon,
      href: "/n/recoveries/recovery-pools",
      visible: true,
      width: 85,
      multifamily: false,
      hospitality: false
    })
  } else {
    navItems.splice(5, 0, {
      name: 'Recoveries',
      hintText: 'V',
      icon: Icons.RecoveriesIcon,
      href: "/recoveries/recovery-pools",
      visible: true,
      width: 85,
      multifamily: false,
      hospitality: false
    })
  }

  if(toggles.displayNewTenantMarket()) {
    navItems.splice(3, 0, {
      name: 'Line Items',
      hintText: 'L',
      icon: Icons.LineItemsIcon,
      href: "/n/line-items/all",
      visible: true,
      width: 85,
      multifamily: false,
      hospitality: false
    })
  } else {
    navItems.splice(3, 0, {
      name: 'Line Items',
      hintText: 'L',
      icon: Icons.LineItemsIcon,
      href: "/line-items",
      visible: true,
      width: 85,
      multifamily: false,
      hospitality: false
    })
  }

  if(toggles.displayMultifamily() && selectedPropType === "Multifamily") {
    navItems.splice(3, 0, {
      name: 'Multifamily',
      hintText: 'M',
      icon: Icons.MFRentIcon,
      href: "/n/multifamily/rent-roll",
      visible: true,
      width: 85,
      multifamily: true,
      hospitality: false
    })
  } else if (toggles.displayHospitality() && selectedPropType === 'Hospitality') {
    navItems.splice(3, 0, {
      name: 'Hospitality',
      hintText: 'A',
      icon: Icons.HospitalityIcon,
      href: "/n/hospitality/rooms",
      visible: true,
      width: 75,
      multifamily: false,
      hospitality: true
    })
  } else if (toggles.displayNewRentRoll()) {
    navItems.splice(3, 0, {
      name: 'Rent Roll',
      hintText: 'R',
      icon: Icons.RentRollIcon,
      href: "/n/rent-roll/home",
      visible: true,
      width: 75,
      multifamily: false,
      hospitality: false
    })
  } else {
    navItems.splice(3, 0, {
      name: 'Rent Roll',
      hintText: 'R',
      icon: Icons.RentRollIcon,
      href: "/rent-roll/home",
      visible: true,
      width: 75,
      multifamily: false,
      hospitality: false
    })
  }
  if (selectedPropType === 'Mixed-Use'){
    navItems.splice(4, 0, {
      name: 'Mixed-Use',
      hintText: 'I',
      icon: Icons.MFRentIcon,
      href: "/n/mixed-use/mf-rent-roll",
      visible: true,
      width: 85,
      multifamily: false,
      hospitality: false
    })
  }

  const assetNavItems = [
    {
      name: 'Asset Mangement',
      hintText: 'D',
      icon: Icons.AMIcon,
      href: "/n/asset-management/asset-list",
      visible: true,
      width: 85,
      multifamily: true,
      hospitality: true,
      visibleNoProperty: true
    },
    {
      name: 'Organization Settings',
      icon: Icons.SettingsIcon,
      href: toggles.displayNewUserAdmin() ? "/n/admin/organization-settings" : "/admin/organization-settings",
      visible: _
        .chain(JSON.parse(localStorage.getItem("auth.profile")))
        .get("roletype.name")
        .isEqual("admin")
        .value()
      ,
      width: 155,
      multifamily: true,
      hospitality: true,
      visibleNoProperty: true
    }
  ]

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
        default:
          if(_.includes(k.chord, "CTRL_ALT_")) {
            const ni = _.find(navItems, i => `CTRL_ALT_${i.hintText}` === k.chord)
            if(ni) {
              const prop = propertyService.get() || {}
              if(k.chord === "CTRL_ALT_M" && prop.type === "Multifamily") {
                navigate("/n/multifamily/rent-roll")
              } else if (k.chord === "CTRL_ALT_M" && prop.type === "Commercial") {
                navigate("/n/property-market/inflation")
              } else if(prop.type === "Multifamily" && !ni.multifamily) {
                return
              } else {
                if(_.includes(ni.href, "/n/")) navigate(ni.href)
                else location.assign(ni.href)
              }
            }
          }
      }
    })

    const socketSubscription = socketService.stream().subscribe(data => {
      switch(data.eventType) {
        case eventType.PROPERTY_SELECTED:
          if(data.event.propertyId) setPropType(_.get(propertyService.get(data.event.propertyId), "type"))
          break;
      }
    })

    const propertySubscription = propertyService.stream().subscribe(data => {
      if (data.state === "ok" || data.state === 'init' && data.current){
        setPropType(data.current ? _.get(_.find(data.value, {propertyid: data.current}), "type") : 'None')
        setBusy(false)
      }  else if (data.state === 'init' && !data.current){
        setPropType('None')
        setBusy(false)
      } else return
    })

    return function cleanup() {
      keySubscription.unsubscribe()
      socketSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [selectedPropType])

  function updateAppMode(appMode){
    setAppMode(appMode)
    setlocal('appMode', appMode)
    appMode === 'asset' ? window.location.replace('/n/asset-management/asset-list') : window.location.replace('/n/folder/explorer')
  }

  const hasAssetManagementModule = currentUserHasAssetManagement && toggles.displayAssetManagement() && local('auth.profile')?.assetmanagement;
  const finalNavItems = appMode === 'asset' && hasAssetManagementModule ? assetNavItems : navItems

  return (
    <Sidebar_s assetManagement={hasAssetManagementModule} summaryBarOpen={props.summaryBarOpen}>
      { hasAssetManagementModule && <AppModes_s>
        <AppMode_s active={appMode === 'property'} onClick={()=>updateAppMode('property')}>Property</AppMode_s>
        <AppMode_s active={appMode === 'asset'} onClick={()=>updateAppMode('asset')}>Asset Management</AppMode_s>
      </AppModes_s> }
      <div>
        { !busy && finalNavItems.map(navItem => {
          if(selectedPropType === "Multifamily" && !navItem.multifamily) return null
          else if (selectedPropType === "Hospitality" && !navItem.hospitality) return null
          else {
            // vvv old
            // const active = window.location.href.includes(navItem.href) && !(window.location.href.endsWith('property-list') && navItem.href === '/property')

            //                                      v /n/multifamily/rent-roll                  v remove /n prefix
            const path      = window.location.pathname;
            let pathArr     = path.split('/');
            let navHrefArr  = navItem.href.split('/')
            pathArr         = pathArr.filter(e => e !== 'n')
            navHrefArr      = navHrefArr.filter(e => e !== 'n')
            let active      = pathArr[1] === navHrefArr[1]
            let visible     = selectedPropType === 'None' && navItem.visibleNoProperty || navItem.visible && selectedPropType !== 'None'

            return visible && (
              <NavItem_s key={navItem.name} href={navItem.href} visible={visible} active={active} onClick={(e) => {
                if (navItem.href.startsWith('/n/') && toggles.useRouterForSidebarLinks()) {
                  e.preventDefault()
                  e.stopPropagation()
                  navigate(navItem.href)
                }
              }}>
                <WithTip position="right">
                  <span>{navItem.name}</span>
                  <Isvg src={navItem.icon} id={`${navItem.name}Icon`} />
                </WithTip>
                <ShortcutHint_s className="left-nav-hint" visible={hintsVisible}>{navItem.hintText}</ShortcutHint_s>
              </NavItem_s>
            )
          }
        })}
      </div>
    </Sidebar_s>
  )
}

export default Sidebar
